import { MoreVert } from "@mui/icons-material"
import { LookupFilter } from "../../components/MaterialTableWrapper/components"
import { contractStatusLookups, eduFormLookups } from "../../constants"
import { contractsService } from "../../services/entrantService"

const useContractsTableProps = (departmentLookups, onOpenMenu, isOperator) => {

    const title = "Договоры"

    const data = query => new Promise((resolve, reject) => {
        const params = {
            page_size: query.pageSize,
            page: query.page + 1,
            search: query.search,
        }

        query.filters.forEach(filter => {
            params[filter.column.field] = filter.column.type === "boolean" ? filter.value === "checked" : filter.value
        })

        contractsService.get(params).then(res => {
            resolve({
                data: res.results,
                totalCount: res.count,
                page: query.page
            })
        }).catch(e => {
            console.error(e)
            reject("Произошла ошибка при загрузке списка договоров")
        })
    })

    const columns = [
        { title: "№ п/п", field: "id", width: 60, filtering: false, },
        { title: "№ дог.", field: "guid", width: 180, filtering: false, },
        isOperator && { title: "ФИО", field: "user_fio", width: 150, filtering: false, },
        { title: "Конкурсная группа", field: "competitive_group", width: 200, filtering: false, },
        { title: "Форма обучения", field: "edu_form", width: 130, lookup: eduFormLookups, filterComponent: LookupFilter },
        { title: "Институт", field: "dep", width: 80, lookup: departmentLookups, filterComponent: LookupFilter },
        { title: "Статус", field: "status", lookup: contractStatusLookups, width: 150, filterComponent: LookupFilter },
    ].filter(x => x)

    const actions = [
        {
            icon: MoreVert,
            iconProps: { color: "secondary" },
            onClick: onOpenMenu
        },
    ]

    const options = {
        pageSize: 50,
        pageSizeOptions: [10, 25, 50, 100],
        padding: "dense",
        maxBodyHeight: "calc(100vh - 117px)",
        minBodyHeight: "calc(100vh - 117px)",
        debounceInterval: 1000,
        headerStyle: { fontSize: 12, position: "sticky", top: 0, zIndex: 1 },
        maxColumnSort: 0,
        tableLayout: "fixed",
        filtering: true,
        emptyRowsWhenPaging: false,
    }

    const style = {
        fontSize: 12,
        minWidth: 1100
    }

    return {
        title,
        data,
        columns,
        actions,
        options,
        style
    }
}

export default useContractsTableProps